import { render, staticRenderFns } from "./CustomTextarea.vue?vue&type=template&id=5bfa93f8&"
import script from "./CustomTextarea.vue?vue&type=script&lang=js&"
export * from "./CustomTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports